export default __webpack_public_path__ + "static/media/2608.c64cb357.png";